<mat-toolbar color="primary">
    <span>Les attestations</span>
    <span class="toolbar-spacer"></span>
</mat-toolbar>
<div style="height:80vh;width:40vw;overflow-y: scroll;">
    <app-contact-services-table [location]="location" [patient]="patient"></app-contact-services-table>
</div>